module.exports = __webpack_public_path__ + "static/media/Appstore.a8873ab0.webp";